import {
    ITableColumn,
    ITableColumnAbook,
    ITableColumnAutoComplete,
    ITableColumnCalc,
    ITableColumnDict,
    ITableColumnUrl,
    TableColumn,
} from '@models/Forms/IForms';

/**
 * Type-guards видов колонок таблиц форм — без тяжёлых импортов, модуль
 * безопасен для таблиц форм и изолированных тестов.
 */
export const isTableColumnDict = (anyObject: unknown): anyObject is ITableColumnDict =>
    (anyObject as ITableColumnDict).dictName !== undefined;

export const isTableColumnCalc = (anyObject: unknown): anyObject is ITableColumnCalc =>
    (anyObject as ITableColumnCalc).formula !== undefined;

export const isTableColumnAutoComplete = (anyObject: unknown): anyObject is ITableColumnAutoComplete =>
    (anyObject as ITableColumnAutoComplete).dataSource != null;

export const isTableColumnAbook = (anyObject: unknown): anyObject is ITableColumnAbook =>
    (anyObject as ITableColumnAbook).tabs !== undefined;

export const isTableColumnUrl = (anyObject: unknown): anyObject is ITableColumnUrl =>
    (anyObject as ITableColumnUrl).href !== undefined;

export const isTableColumn = (anyObject: unknown): anyObject is ITableColumn =>
    anyObject !== null &&
    !isTableColumnDict(anyObject) &&
    !isTableColumnCalc(anyObject) &&
    !isTableColumnAutoComplete(anyObject) &&
    !isTableColumnAbook(anyObject) &&
    !isTableColumnUrl(anyObject);

export const hasFormValuesTableColumn = (column: TableColumn): column is ITableColumnDict | ITableColumnAbook =>
    (column as ITableColumnDict | ITableColumnAbook).formValues !== undefined;

export const getRowFormValues = (
    rowData: Record<string, unknown>,
    column: ITableColumnDict | ITableColumnAbook,
): Record<string, unknown> | null => {
    if (!column.formValues?.formValue) return null;
    return column.formValues.formValue.reduce(
        (acc, formValue) => {
            acc[formValue.key] = rowData[formValue.attr];
            return acc;
        },
        {} as Record<string, unknown>,
    );
};

/** Совпадают ли formValues у всех строк (мультиредактирование колонки применимо
 *  только к строкам с одинаковыми параметрами справочника/АК). Возвращает null
 *  при консистентности, иначе — список различающихся значений для сообщения. */
export const findFormValuesInconsistency = (
    rows: Array<Record<string, unknown>>,
    column: ITableColumnDict | ITableColumnAbook,
): string | null => {
    if (rows.length <= 1) return null;
    const first = getRowFormValues(rows[0], column);
    const different = new Set<string>();
    for (const row of rows) {
        const current = getRowFormValues(row, column);
        if (!first || !current) continue;
        for (const key of Object.keys(first)) {
            if (JSON.stringify(first[key]) !== JSON.stringify(current[key])) {
                different.add(column.formValues.formValue.find((fv) => fv.key === key)?.displayName ?? key);
            }
        }
    }
    return different.size > 0 ? Array.from(different).join(', ') : null;
};
